import { Route, Switch } from 'react-router-dom';
import ActiveEventHeader from '../headers/active-event-header';
import RegistrationPanel from './registration-panel';
import RegistrationSettings from '../settings/registration-settings/registration-settings';
import PaidTicketingSettings from '../settings/registration-settings/paid-ticketing';
import { PATHNAMES } from "../../../../../admin";

const Registration: React.FC = () => {
	return (
		<Switch>
			<Route path={PATHNAMES.Event.Availability}>
				<ActiveEventHeader title="Event availability" />
				<RegistrationSettings />
			</Route>
			<Route path={PATHNAMES.Event.Ticketing}>
				<ActiveEventHeader title="Paid ticketing" />
				<PaidTicketingSettings />
			</Route>
			<Route>
				<RegistrationPanel />
			</Route>
		</Switch>
	);
};

export default Registration;